import { render, staticRenderFns } from "./VueUploadImgs.vue?vue&type=template&id=a5724f32&"
import script from "./VueUploadImgs.vue?vue&type=script&lang=js&"
export * from "./VueUploadImgs.vue?vue&type=script&lang=js&"
import style0 from "./VueUploadImgs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports